import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { URL } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class CanonicalService {
    constructor(
        @Inject(DOCUMENT) private readonly document: Document,
    ) {}

    /**
     * Sets a self-referencing <link rel="canonical"> for the current page.
     * Uses URL.CHILEFIRMAS_WEBSITE (https://www.chilefirmas.cl/), the same
     * value declared in sitemap.xml, always with a trailing slash so the
     * with/without trailing-slash variants are deduplicated.
     *
     * @param path Route path without domain, e.g. 'autoatencion' or '' for home.
     */
    set(path: string): void {
        const cleanPath = this.trimSlashes(path);
        const base = this.trimSlashes(URL.CHILEFIRMAS_WEBSITE);
        const canonicalUrl = cleanPath ? `${base}/${cleanPath}/` : `${base}/`;

        let link = this.document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
        if (!link) {
            link = this.document.createElement('link');
            link.setAttribute('rel', 'canonical');
            this.document.head.appendChild(link);
        }
        link.setAttribute('href', canonicalUrl);
    }

    /** Removes leading and trailing slashes without using a regex (avoids ReDoS). */
    private trimSlashes(value: string): string {
        let start = 0;
        let end = value.length;
        while (start < end && value.charAt(start) === '/') {
            start++;
        }
        while (end > start && value.charAt(end - 1) === '/') {
            end--;
        }
        return value.substring(start, end);
    }
}
